var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "support-login" }, [
    _c(
      "form",
      {
        staticClass: "ct-register-form ct-card form-horizontal",
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.login()
          }
        }
      },
      [
        _c("section", [
          _c("h3", [_vm._v(_vm._s(_vm.$t("label.login")))]),
          _vm._v(" "),
          _c("div", { staticClass: "ct-input-element" }, [
            _c("div", { staticClass: "ct-title ct-v-align" }, [
              _c("label", { attrs: { for: "username" } }, [
                _vm._v(_vm._s(_vm.$t("label.username")) + "*")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ct-content" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.username,
                    expression: "username"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "username", type: "text" },
                domProps: { value: _vm.username },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.username = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ct-input-element" }, [
            _c("div", { staticClass: "ct-title ct-v-align" }, [
              _c("label", { attrs: { for: "password" } }, [
                _vm._v(_vm._s(_vm.$t("label.password")) + "*")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ct-content" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "password", type: "password" },
                domProps: { value: _vm.password },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "notice-area" }, [
          _vm.showMessage
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "alert alert-danger",
                    attrs: { role: "alert" }
                  },
                  [_vm._v(_vm._s(_vm.$t("support.login.error")))]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showSpinner ? _c("div", [_c("spinner")], 1) : _vm._e()
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "ct-action" }, [
          _c("div", { staticClass: "ct-input-element" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.login()
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("button.login")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c12da00", { render: render, staticRenderFns: staticRenderFns })
  }
}